module.exports = __webpack_public_path__ + "9d7f731d7f2340607eb96a579080af40.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/reading/take-a-quiz.png
// module id = 220
// module chunks = 0